import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import moment from "moment";

// External components
import SubscriptionStatusBadge from "@/components/subscriptionStatusBadge/subscriptionStatusBadge";
import MealCard from "@/components/mealCard/mealCard";
import OrderPreviewHeader from "../OrderPreviewHeader/OrderPreviewHeader";

// Helpers
import {
  isOrderInTerminalStatus,
  orderStatusToSpanishLabel,
  isDeliveryAvailable,
} from "@/plugins/subscriptions_helper";
import { isMissingDocumentInformation } from "@/plugins/user_helper";
@Component({
  methods: { moment },
  components: { SubscriptionStatusBadge, MealCard, OrderPreviewHeader },
})
export default class OrderPreview extends Vue {
  @Prop({ default: null }) order;

  @Getter getCurrentOrder;
  @Getter getIsUnderMobile;
  @Getter getUser;
  @Getter getSubscription;

  get isBlockingOrder() {
    if (this.isLastOrder) return false;
    else return isDeliveryAvailable(this.getSubscription) === false;
  }

  get isLastOrder() {
    return this.order.json_products;
  }

  get orderDealDate() {
    const { programmed_for, deal_date } = this.order;
    if (this.isLastOrder) return programmed_for;
    return deal_date;
  }

  get getMenuPreview() {
    const { details_subscription_menus } = this.order;
    for (let i = 0; i < details_subscription_menus.length; i++) {
      if (details_subscription_menus[i].count) return details_subscription_menus[i];
    }
    return [];
  }

  get getPlates() {
    // Return plates sorted by count_id (ascending)
    return this.getMenuPreview.day.sort((a, b) => {
      return a.count_id - b.count_id;
    });
  }

  get isLastOrderInTerminalStatus() {
    if (this.getCurrentOrder) {
      return isOrderInTerminalStatus(this.getCurrentOrder);
    }
    return true;
  }

  get orderStatusLabel() {
    const { status, deadline_update_date, programmed_for } = this.order;
    if (!this.isLastOrder) {
      if (this.isLastOrderInTerminalStatus) {
        return {
          label: `Confirma antes del ${moment(deadline_update_date).format("ddd DD MMM hh:mm A")}`,
          color: "orange",
        };
      } else {
        const { deal_date } = this.getSubscription;
        return {
          label: `Personaliza tu pedido como prefieras. Podrás confirmarlo a partir del ${moment(
            deal_date
          ).format("dddd DD [de] MMMM")}`,
          color: "black",
        };
      }
    } else {
      const dealDate = moment(programmed_for).format("DD [de] MMM");
      return orderStatusToSpanishLabel(status, dealDate);
    }
  }

  reviewOrder() {
    if (this.isLastOrder) {
      this.$router.push({ name: "subscriptionLastOrderDetail" });
    } else {
      this.$router.push({ name: "subscriptionNextOrderDetail" });
    }
    document
      .getElementById("SubscriptionDashboard")
      .scroll({ top: 0, left: 0, behavior: "smooth" });
  }

  payOrder() {
    if (isMissingDocumentInformation(this.getUser)) {
      this.$emit("add-document");
    } else {
      window.open(`https://checkout.wompi.co/l/${this.order.payment_link}`, "_blank");
    }
  }
}
